var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu"},[(_vm.isOpen)?_c('ContextMenu',{attrs:{"x":_vm.contextMenuPosition.x,"y":_vm.contextMenuPosition.y},on:{"close":_vm.handleClose}},[_c('div',{staticClass:"menu-container",style:({ 'max-width': _vm.contextMenuPosition.maxWidth + 'px', 'max-height': _vm.contextMenuPosition.maxHeight + 'px'})},[(_vm.enabledOptions['copy'])?_c('menu-item',{attrs:{"option":{
          icon: 'copy',
          label: '<b>' + _vm.answerPrefix + '</b> ' + _vm.message,
        },"variant":"message"},on:{"click":_vm.handleCopy}}):_vm._e()],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }